<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getUserReferrals} from 'src/components/cabinet/#services/getUserReferrals'
    import IconifyIcon from '@iconify/svelte'
    import yesIcon from '@iconify/icons-fa-solid/angry'
    import noIcon from '@iconify/icons-fa-solid/smile'

    export let userId

    let currentPage = 0
    let perPage = 15
    let maxButtons = 5

    $: getUserReferrals.send({
        data: {
            userId,
            page: currentPage + 1,
            perPage,
        },
    })
</script>

<div class="referrals-list">
    {#if $getUserReferrals.value && $getUserReferrals.value > 0 }
        <p>Referrals count: { $getUserReferrals.value.totalCount }</p>
    {/if}

    <Table bordered striped responsive>
        <thead>
            <tr>
                <td class="text-center">Support ID</td>
                <td class="text-center">Nickname</td>
                <td class="text-center">Ban</td>
                <td class="text-center">Registered</td>
            </tr>
        </thead>
        <tbody>
        {#if $getUserReferrals.loading}
            {#each {length: perPage} as item}
                <tr>
                    <td><span class="loading referrals-loading"></span></td>
                    <td><span class="loading referrals-loading"></span></td>
                    <td><span class="loading referrals-loading"></span></td>
                    <td><span class="loading referrals-loading"></span></td>
                </tr>
            {/each}
        {:else if $getUserReferrals.error || !$getUserReferrals.hasValue }
            <tr>
                <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else}
            {#each $getUserReferrals.value.data as { userId, nickname, isBanned, registryDate }}
                <tr>
                    <td class="text-center">{userId}</td>
                    <td class="text-center"><a href="/profile/{userId}" target="_blank" rel="noreferrer">{nickname.replace(/#([^#]+)$/, '')}</a></td>
                    <td class="text-center">
                        {#if isBanned}
                            <span title="Banned"><IconifyIcon icon={yesIcon} class="angry"/></span>
                        {:else}
                            <span title="Not banned"><IconifyIcon icon={noIcon} class="smile"/></span>
                        {/if}
                    </td>
                    <td class="text-center">{new Date(registryDate).toLocaleString()}</td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="4">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $getUserReferrals.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getUserReferrals.value.totalCount}
            {perPage}
            {maxButtons}
            disabled={$getUserReferrals.loading || $getUserReferrals.loading}
        />
    {/if}
</div>

<style>
    .referrals-list :global(.angry) {
        color: #f44336;
        font-size: 20px;
    }

    .referrals-list :global(.smile) {
        color: #4c9844;
        font-size: 20px;
    }

    .referrals-list :global(table) {
        width: auto;
    }

    .referrals-list :global(.btn.btn-primary) {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
    }

    .referrals-list :global(td) {
        vertical-align: middle;
        padding: 6px 25px;
        line-height: normal;
    }

    .referrals-list :global(nav .pagination) {
        justify-content: flex-start;
    }

    .referrals-loading {
        height: 24px;
        width: 100%;
        display: block;
    }
</style>
